import _ from "lodash";
import store from "services/redux/store";
import { addDataByGuid } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchFloor from "utils/fetch/FetchFloor";

export default class FetchCachedFloor
{
	static logName = 'FetchCachedFloor';
	static values = null;
	static cacheUpdatedAt = null;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'floors',
				tables: [ 'office_floor' ],
				onExpire: this.reload,
				updated_at_max_age: ( 5 * 60 ) // updated_at needs to be refresh at most each 5 minutes for this table
			}, this.process )
		);
	};

	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
				onFresh: () => {
					if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
						callbackSuccess( this.values )
					}
				},
				onExpired: () => {
					this.reload( {callbackSuccess, callbackError, callbackStart} )
				}
		})
			);
		});
	}

	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchFloor.fetchAll({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( floors ) => {
						// Save to object
						this.process( floors );

						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, floors, true );

						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess( floors );
						}
					}
				})
			);
		}
		);
	}

	static process = ( floors ) => {
		this.values = floors;
		
		store.dispatch( addDataByGuid( dataConstants.FLOORS, this.values ) );
	}
}
